import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountriesRoutingModule } from './countries-routing.module';
import { CountriesComponent } from './countries.component';
import { CreateCountryComponent } from './create-country/create-country.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FormFieldModule } from "../../shared/controls/form-field/form-field.module";
import { EditCountryComponent } from './edit-country/edit-country.component';
import { ControlsModule } from 'src/app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { LoaderComponent } from 'src/app/shared/reusable/loader/loader.component';



@NgModule({
    declarations: [
        CountriesComponent,
        CreateCountryComponent,
        EditCountryComponent,
        
    ],
    imports: [
        CommonModule,
        CountriesRoutingModule,
        MatDialogModule,
        ReactiveFormsModule,
        TranslateModule,
        FormsModule,
        FormFieldModule,
        ControlsModule,
        NgbModule,
        ReusableModule
    ]
})
export class CountriesModule { }
